import { css, Styles, verticalScrollCss, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  vacanciesListContainer: ({ theme }) => css`
    & > div > div {
      ${verticalScrollCss(theme)}
    }
  `,
  inputContainer: css`
    margin-left: 16px;
    margin-right: 16px;
  `,
  input: css`
    width: calc(100% - 16px);
    margin-bottom: 8px;
    align-self: center;
  `,
  dialogBody: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
